import { useContext } from 'react';
import { AdvertCardContext, AdvertCardContextType } from '#advert/components/card';

const useAdvertCardContext = () => useContext<AdvertCardContextType>(AdvertCardContext);

export { useAdvertCardContext };
